import { getAllComments, createComments, updateComments } from "src/actions/commentsActions";

export const REQUEST_COMMENTS = "request_comments";
export const RECEIVE_COMMENTS = "receive_comments";
export const RECEIVE_COMMENTS_ERROR = "receive_comments_error";

export const RECEIVE_UPDATE_COMMENTS = "receive_update_comments";
export const REQUEST_UPDATE_COMMENTS = "request_update_comments";
export const UPDATE_COMMENTS_ERROR = "update_comments_error";

export const RECEIVE_CREATE_COMMENTS = "receive_create_comments";
export const REQUEST_CREATE_COMMENTS = "request_create_comments";
export const CREATE_COMMENTS_ERROR = "create_comments_error";

const getAllCommentsRedux = () => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_COMMENTS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_COMMENTS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: RECEIVE_COMMENTS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const { comments } = await getAllComments();
			return onSuccess(comments);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

const createCommentsRedux = commentsToCreate => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_CREATE_COMMENTS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_CREATE_COMMENTS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: CREATE_COMMENTS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await createComments(commentsToCreate);
			const { createdComments } = response;

			return onSuccess(createdComments);
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

const updateCommentsRedux = (commentsId, commentsToUpdate, action, activityToAdd) => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_UPDATE_COMMENTS,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_UPDATE_COMMENTS,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: UPDATE_COMMENTS_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const response = await updateComments(commentsId, commentsToUpdate, action, activityToAdd);
			const { updatedComments } = response;
			return onSuccess({ ...updatedComments, action });
		} catch (error) {
			console.log(error);

			return onError(error);
		}
	};
};

export { createCommentsRedux, getAllCommentsRedux, updateCommentsRedux };
